import React, { FC } from 'react';
import { Skeleton, Stack, useTheme } from '@mui/material';

export const MetricListSkeleton: FC = () => {
  const theme = useTheme();

  const metrics = [
    { labelWidth: 100, valueWidth: 120, primary: true },
    { labelWidth: 110, valueWidth: 100 },
    { labelWidth: 60, valueWidth: 100 },
  ];

  return (
    <Stack direction="row" flex={1} mt={4} gap={2} alignItems="flex-end">
      {metrics.map((metric, index) => (
        <React.Fragment key={index}>
          {/* Metric container */}
          <Stack flex={1} alignItems={{ xs: 'center', sm: 'flex-start' }}>
            {/* Metric label */}
            <Skeleton
              variant="text"
              width={metric.labelWidth}
              height={20}
              sx={{ mb: 1 }}
            />

            {/* Metric value - larger for primary */}
            <Skeleton
              variant="text"
              width={metric.valueWidth}
              height={metric.primary ? 56 : 48}
              sx={{
                fontSize: {
                  xs: theme.typography.pxToRem(32),
                  sm: theme.typography.pxToRem(48),
                },
              }}
            />
          </Stack>

          {/* Separator */}
          {index < metrics.length - 1 && (
            <Skeleton
              variant="text"
              width={20}
              height={48}
              sx={{
                fontSize: {
                  xs: theme.typography.pxToRem(32),
                  sm: theme.typography.pxToRem(48),
                },
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};
